import { ref, Ref, computed, defineAsyncComponent, AsyncComponentLoader } from 'vue'

const isReloadModalVisible: Ref<boolean> = ref(false)

export const useReloadModal = () => {
  return {
    isReloadModalVisible: computed(() => isReloadModalVisible.value)
  }
}

export const asyncComponentWrapper = (component: AsyncComponentLoader) =>
  defineAsyncComponent({
    loader: component,
    onError: (error, retry, fail, attempts) => {
      if (attempts < 3) {
        setTimeout(() => retry(), 100)
      } else {
        isReloadModalVisible.value = true
      }
    }
  })
